<script lang="ts" setup>
</script>

<template>
  <svg
    width="100" height="101" viewBox="0 0 100 101" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" transform="translate(0 0.5)" />
    <path d="M89 39.5V31.5H80V29.5H89C90.1046 29.5 91 30.3954 91 31.5V39.5C91 40.6046 90.1046 41.5 89 41.5H80V39.5H89Z" fill="#8A9096" />
    <path d="M9 39.5V31.5C9 30.3954 9.89543 29.5 11 29.5H20V31.5H11V39.5H20V41.5H11C9.89543 41.5 9 40.6046 9 39.5Z" fill="#8A9096" />
    <path d="M89 69.5V61.5H80V59.5H89C90.1046 59.5 91 60.3954 91 61.5V69.5C91 70.6046 90.1046 71.5 89 71.5H80V69.5H89Z" fill="#8A9096" />
    <path d="M9 69.5V61.5C9 60.3954 9.89543 59.5 11 59.5H20V61.5H11V69.5H20V71.5H11C9.89543 71.5 9 70.6046 9 69.5Z" fill="#8A9096" />
    <path
      d="M22.25 78.25H77.75V22.75H22.25V78.25ZM82.25 78.5C82.25 80.8472 80.3472 82.75 78 82.75H22C19.6528 82.75 17.75 80.8472 17.75 78.5V22.5C17.75 20.1528 19.6528 18.25 22 18.25H78C80.3472 18.25 82.25 20.1528 82.25 22.5V78.5Z"
      fill="black" />
  </svg>
</template>
